<template>
  <section class="pin-lei-dong-cha">
    <PageBlock title="品类洞察">
      <div class="content">
        <ButtonList :btnList="buttonList" @click="buttonClick"></ButtonList>
        <div style="text-align: center;color: #fff;font-size: 14px;line-height: 28px">销售趋势</div>
        <div ref="chart" style="width: 100%;height: 240px;"></div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
import PageBlock from "@/components/page-block.vue";
import ButtonList from "@/components/button-list.vue";
import dayjs from "dayjs";
export default {
  name: 'pin-lei-dong-cha',
  components: {
    PageBlock,
    ButtonList
  },
  props: {
    categoryAnalysisVoList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    categoryAnalysisVoList: {
      handler(val) {
        this.buttonList = val.map(item => {
          this.dataObj[item.category] = item.categoryAnalysisList
          return item.category
        })
        if (!this.activeBtn) {
          this.activeBtn = this.buttonList[0]
          this.activeData = this.dataObj[this.activeBtn]
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      buttonList: [],
      date: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dataObj: {},
      activeBtn: '',
      activeData: {},
      chart: null
    };
  },
  mounted() {
    console.log('import pinLeiDongCha from "@/pages/admin/components/pin-lei-dong-cha.vue";')
    this.initChart()
  },
  methods: {
    buttonClick (data) {
      console.log(data)
      this.activeBtn = data
      this.activeData = this.dataObj[this.activeBtn]
      this.chart.dispose()
      this.initChart()
    },
    initChart () {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            let topDiv = '<div>'
            params.forEach((item, index) => {
              if (index === 0) {
                let data = this.activeData[item.dataIndex]
                topDiv += `<div>${dayjs(data.date).format('YYYY年MM月')}</div>`
              }
              topDiv += `<div>${item.marker}<span>${item.seriesName}: ${item.value}万元</span></div>`
            })
            topDiv += '<div>'
            return topDiv
          }
        },
        legend: {
          data: ['销售额', '同比增长率'],
          right: "0%",
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '40',
          bottom: 20
        },
        xAxis: [
          {
            type: 'category',
            data: this.activeData.map(item => dayjs(item.date).format('MM月')),
            // data: this.date,
            axisPointer: {
              type: 'shadow'
            },
            // axisLine: {
            //   show: false
            // }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '万元',
            // min: 0,
            // interval: 50,
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            splitLine: {
              show: false
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // interval: 5,
            axisLabel: {
              formatter: '{value}%',
              color: '#fff'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '销售额',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '万元';
              }
            },
            data: this.activeData.map(item => item.sale)
            // data: this.dateList[this.activeBtn]
          },
          // {
          //   name: '同比增长率',
          //   type: 'line',
          //   yAxisIndex: 1,
          //   tooltip: {
          //     valueFormatter: function (value) {
          //       return value + '%';
          //     }
          //   },
          //   data: this.yearRetailTrendVoList.map(item => parseFloat(item.growthRate))
          //   // data: [0,0,0,0,0,0,0,0,0,0,0,0,0]
          // }
        ]
      };
      // 设置配置项
      this.chart.setOption(option)
    }
  },
};
</script>

<style scoped>
.pin-lei-dong-cha {
  .content{
    .list{
      display: flex;
      gap: 12px;
      font-size: 11px;
      color: #fff;
      >div{
        background: rgba(102, 255, 255, 0.17);
        padding: 3px 6px;
        cursor: pointer;
      }
    }
  }
}
</style>
